import { BiFormComp, BiListComp, BiPageComp } from './components';

import { FormProvider } from 'context/FormContext';
import { ListagemProvider } from 'context/ListagemContext';
import { usePermissionsContext } from 'context/PermissionsContext';

export function BiPage() {
    return <BiPageComp />;
}

export function BiList() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();

    if (!hasPermission(['COMPLEMENTAR_CONFIG_BI'])) return alertNotPermission();

    return (
        <ListagemProvider>
            <BiListComp />
        </ListagemProvider>
    );
}

export function BiForm() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();

    if (!hasPermission(['COMPLEMENTAR_CONFIG_BI'])) return alertNotPermission();

    return (
        <FormProvider>
            <BiFormComp />
        </FormProvider>
    );
}
